/**
 * @file 模型库
 * @author Fanjinliang(fanjinliang@baidu.com)
 */

import React from 'react';
import { ModelLibraryItem } from '../../types';

interface IProps {
    model: ModelLibraryItem;
}

const PaddleNlpModelBlock: React.FC<IProps> = props => {
    const { model } = props;
    return (
        <>
            <div className="model-library-block-name">{model.title}</div>
            <div className="model-library-container">
                {model.list.map((item, index) => {
                    return (
                        <div key={index} className="model-library-grid">
                            <div
                                className="model-library-grid-title center-text"
                                style={{ gridRow: `1 / ${1 + Math.floor(item.modelList.length / 6)}` }}
                            >
                                {item.title}
                            </div>
                            {item.modelList.map((model, key) => {
                                return (
                                    <div
                                        key={key}
                                        className="model-library-grid-item"
                                        onClick={() => window.open(model.link)}
                                    >
                                        {model.title}
                                        {/* todo: 这边做个是否热门的判断，和热门tag的字段 */}
                                        {model.label && (
                                            <div className="model-library-hot-tag center-text">{model.label}</div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default PaddleNlpModelBlock;
